import { Observable } from 'rxjs'
import { FlexPositionsExportRequest } from '../models/flex-positions-export.model'
import { SourceKey } from '../models/source-key.model'

/**
 * Seam between the workbench grid's "Export to Excel" and the Flex Positions export API, mirroring
 * the {@link WorkbenchDataSource} seam. The panel binds {@link HttpPositionsExportService}.
 */
export abstract class PositionsExportService {
  /**
   * Ask the backend to render `request` as an `.xlsx` workbook for `source`, resolving to the file.
   *
   * Errors with no request sent for a source that has no export endpoint (Clearwater) — callers are
   * expected to guard that case themselves; the error is a backstop, not the UX.
   */
  abstract exportToExcel(
    source: SourceKey,
    request: FlexPositionsExportRequest,
  ): Observable<Blob>
}
